export default {
  downtimeUrl: "https://id2.kodland.tech",
  hookId: "bh4vgc2iq8nf8m3wd8g2au3f4tsv8220",
  startPage: {
    image: "/welcome/quiz_indo_bf_desktop.png",
    imageMobile: "/welcome/quiz_indo_bf_mobile.png",
    title: "Jawablah 5 pertanyaan dan dapatkan pelajaran GRATIS untuk anak anda",
    subtitle:
      "Anak-anak akan mencoba kreativitas digital mereka: kartun, animasi, ilustrasi, pemodelan, 3D, desain",
    button: "Mulai  🚀",
  },
  successPage: {
    title: "Pilih tanggal dan waktu untuk mendapatkan pelajaran 🚀 GRATIS 🚀",
    subtitle: "Klik tombol “📆 Pesan” dan dapatkan pelajarannya.",
    button: "📆 Pesan",
  },
  quizRotateBySteps: {
    1: {
      question: "Bagaimana biasanya anak Anda menghabiskan waktu luangnya?",
      answers: [
        "📱 Bermain game di HP atau komputer",
        "👽 Menonton kartun",
        "♟️ Bermain permainan papan",
        "👨‍👩‍👧‍👦 Menghabiskan waktunya dengan keluarga",
        "👥 Menghabiskan waktunya dengan teman",
        "⛹️ Bermain kegiatan olahraga",
        "🎨 Melakukan aktivitas seni: menggambar, musik, akting, dsb.",
      ],
    },
    2: {
      question: "Apakah anak Anda mengikuti kegiatan ekstrakurikuler di luar pembelajaran sekolah?",
      answers: ["⛹️ Ya", "✖️ Tidak. Anak tidak memiliki waktu untuk itu"],
    },
    3: {
      question: "Apakah Anda dapat terhubung ke kelas uji coba gratis dari komputer atau laptop?",
      answers: ["💻 Ya", "🙁 Tidak"],
    },
  },
};
